import { IMicrositeConfiguration } from 'src/interfaces/microsite';
import IPackageConfiguration from '@orcha/types/package';
import { MicrositeService } from 'src/services';
import ProtectedPageRoute from 'src/utilities/auth/protectedPageRoute';
import { ReactElement } from 'react';
import ResolvePageComponent, {
  ResolvePageComponentProps,
} from 'src/components/pages/ResolvePageComponent';
import RootWidgetLayout from 'src/components/layouts/RootWidgetLayout';
import { Services } from 'src/services/types';
import { Translate } from 'next-translate';
import { myContainer } from 'src/services/inversify.config';
import { pageWidgetDataFetcher } from 'src/utilities/pageWidgetDataFetcher';

const DynamicPageRoute = (props: ResolvePageComponentProps) => (
  <ResolvePageComponent {...props} />
);

export const getServerSideProps = async (context) =>
  ProtectedPageRoute(context, async () => {
    let props = {};
    const { req, params, locale, res } = context;
    const { site } = req as { site?: IMicrositeConfiguration };
    res.setHeader(
      'Cache-Control',
      'public, s-maxage=10, stale-while-revalidate=59'
    );

    const { packageConfig } = req as {
      packageConfig?: IPackageConfiguration;
    };

    if (params?.urlSlug) {
      const micrositeService = myContainer.get<MicrositeService>(
        Services.MicrositeService
      );

      const pageData = site
        ? await micrositeService.getPageBySlug(
            site.tenantId,
            site.packageId,
            params.urlSlug,
            locale
          )
        : undefined;

      if (
        site &&
        packageConfig &&
        pageData?.pageType === 'Dynamic' &&
        pageData?.configuredWidgets
      ) {
        const widgetData = await pageWidgetDataFetcher(
          pageData,
          site,
          locale,
          packageConfig
        );

        pageData.configuredWidgets = widgetData;
      }

      // Prevents serializing issue with undefined in large JSON objects (App data)
      props = JSON.parse(
        JSON.stringify({
          pageData,
          pageTitle: pageData?.pageName,
          breadcrumbSkeletonCount: params.urlSlug.length,
        })
      );
    }

    return props;
  });

export default DynamicPageRoute;

DynamicPageRoute.getLayout = (
  page: ReactElement,
  _t: Translate,
  pageTitle?: string
) => {
  return <RootWidgetLayout pageTitle={pageTitle}>{page}</RootWidgetLayout>;
};
